/* PRABFA — live marketplace prices on the compare-channel buttons.
 *
 * The button markup and its list prices come from the master workbook through
 * snippets/marketplace-data.liquid, so what is painted on first load is the
 * list price. This fetches what the three shops are actually charging right
 * now and overwrites those figures.
 *
 * The prices come from the same cache the mesoestetic site reads, because both
 * sites link to the same marketplace listings: the Shopee shop id, the Lazada
 * shop and the TikTok channel in the workbook are all mesoestetic's. The cache
 * is keyed by product handle, and every handle the two sites share was checked
 * to point at the same item, so one lookup serves both correctly.
 *
 * Doing nothing is a valid outcome: no endpoint, no answer, a channel missing
 * from the reply or a failed request all leave the list price in place.
 */
(function () {
  'use strict';

  // The workbook calls the TikTok channel "tiktok_meso", which handleize turns
  // into "tiktok-meso"; the cache calls it "tiktok".
  var CHANNEL_SELECTOR = {
    shopee: '[data-marketplace="shopee"]',
    lazada: '[data-marketplace="lazada"]',
    tiktok: '[data-marketplace="tiktok-meso"], [data-marketplace="tiktok"]'
  };

  function baht(n) {
    return Number(n).toLocaleString('en-US') + ' ฿';
  }

  function ago(iso) {
    if (!iso) return '';
    var mins = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 60000));
    if (mins < 1) return 'เมื่อสักครู่';
    if (mins < 60) return mins + ' นาทีที่แล้ว';
    var hours = Math.round(mins / 60);
    if (hours < 24) return hours + ' ชั่วโมงที่แล้ว';
    return Math.round(hours / 24) + ' วันที่แล้ว';
  }

  function apply(root) {
    if (root.dataset.pfLivePrices) return;
    root.dataset.pfLivePrices = '1';

    var endpoint = (root.getAttribute('data-prices-endpoint') || '').replace(/\/+$/, '');
    var handle = root.getAttribute('data-handle') || '';
    if (!endpoint || !handle) return;

    fetch(endpoint + '/marketprices?handle=' + encodeURIComponent(handle))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.ok || !data.item) return;

        var updated = 0;
        Object.keys(CHANNEL_SELECTOR).forEach(function (channel) {
          var info = data.item[channel];
          if (!info || !info.price) return;
          var button = root.querySelector(CHANNEL_SELECTOR[channel]);
          if (!button) return;
          var priceEl = button.querySelector('.marketplace-buttons__price');
          if (!priceEl) return;
          priceEl.textContent = baht(info.price);
          button.setAttribute('data-live-price', '1');
          updated++;
        });
        if (!updated) return;

        var stamp = root.querySelector('.marketplace-buttons__live');
        if (!stamp) {
          stamp = document.createElement('p');
          stamp.className = 'marketplace-buttons__live';
          (root.querySelector('.marketplace-buttons__note') || root).insertAdjacentElement('afterend', stamp);
        }
        stamp.textContent = 'ราคาอัปเดตล่าสุด ' + ago(data.updatedAt);
      })
      .catch(function () {});
  }

  function boot() {
    document.querySelectorAll('[data-marketplace-buttons][data-prices-endpoint]').forEach(apply);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
